import React, { useState, useEffect } from "react";

import { getImageBaseUrl } from "../../../apis/apiSettings";
import thumbnail_not_computed from "../../../assets/Thumbnails/thumbnail_not_computed_1.jpg";

const Thumbnail = ({ thumbnail, imageStyle }) => {
  // Initialize the src with either the thumbnail or the placeholder
  const [currentSrc, setCurrentSrc] = useState(
    thumbnail ? getImageBaseUrl() + thumbnail : thumbnail_not_computed
  );

  useEffect(() => {
    setCurrentSrc(
      thumbnail ? getImageBaseUrl() + thumbnail : thumbnail_not_computed
    );
  }, [thumbnail]);

  const handleError = () => {
    // If the image fails to load, set src to the placeholder
    setCurrentSrc(thumbnail_not_computed);
  };

  return (
    <img
      className={imageStyle}
      src={currentSrc}
      onError={handleError}
      draggable={false}
      alt={"Thumbnail not computed."}
    />
  );
};

export default Thumbnail;
